module.exports = __webpack_public_path__ + "static/media/map.4c7feb21.svg";